"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDirectDebitSummary = void 0;
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var useDirectDebitSummary = function (accountId) {
    var directDebitLegacyQueryResult = (0, legacy_queries_1.useDirectDebitLegacyQuery)(accountId);
    var recommendedDirectDebitLegacyQueryResult = (0, legacy_queries_1.useRecommendedDirectDebitLegacyQuery)(accountId);
    var legacyLoading = directDebitLegacyQueryResult.isFetching ||
        recommendedDirectDebitLegacyQueryResult.isFetching;
    var legacyError = directDebitLegacyQueryResult.status === 'error'
        ? directDebitLegacyQueryResult.error
        : undefined;
    var legacyData = directDebitLegacyQueryResult.status === 'data'
        ? {
            directDebit: directDebitLegacyQueryResult.data,
            recommendedDirectDebit: recommendedDirectDebitLegacyQueryResult.status === 'data'
                ? recommendedDirectDebitLegacyQueryResult.data
                : null,
        }
        : undefined;
    return {
        loading: legacyLoading,
        error: legacyError,
        data: legacyData,
    };
};
exports.useDirectDebitSummary = useDirectDebitSummary;
